import { v4 as uuid } from 'uuid';

// import media files
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';
import Avatar6 from 'assets/images/avatar/avatar-6.jpg';
import Avatar7 from 'assets/images/avatar/avatar-7.jpg';
import Avatar18 from 'assets/images/avatar/avatar-18.jpg';
import Avatar12 from 'assets/images/avatar/avatar-12.jpg';
import Avatar13 from 'assets/images/avatar/avatar-13.jpg';
import Avatar14 from 'assets/images/avatar/avatar-14.jpg';
import Avatar17 from 'assets/images/avatar/avatar-17.jpg';
import Avatar15 from 'assets/images/avatar/avatar-15.jpg';

export const TeamData = [
	{
		id: uuid(),
		name: 'Jenny Wilson',
		image: Avatar1,
		topic: 'Front-end Developer, Designer'
	},
	{
		id: uuid(),
		name: 'Dianna Smiley',
		image: Avatar2,
		topic: 'Front End Developer'
	},
	{
		id: uuid(),
		name: 'Nia Sikhone',
		image: Avatar17,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: uuid(),
		name: 'Jacob Jones',
		image: Avatar14,
		topic: 'Bootstrap Expert'
	},
	{
		id: uuid(),
		name: 'Kristin Watson',
		image: Avatar7,
		topic: 'Web Development'
	},
	{
		id: uuid(),
		name: 'Nia Sikhone',
		image: Avatar17,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: uuid(),
		name: 'Rivao Luke',
		image: Avatar17,
		topic: 'Web Development'
	},
	{
		id: uuid(),
		name: 'Nia Sikhone',
		image: Avatar4,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: uuid(),
		name: 'Xiaon Merry',
		image: Avatar6,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: uuid(),
		name: 'Sina Ray',
		image: Avatar3,
		topic: 'Engineering Architect'
	},
	{
		id: uuid(),
		name: 'Kristin Watson',
		image: Avatar15,
		topic: 'Web Development'
	},
	{
		id: uuid(),
		name: 'Jacob Jones',
		image: Avatar14,
		topic: 'Bootstrap Expert'
	},
	{
		id: uuid(),
		name: 'Nia Sikhone',
		image: Avatar17,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: uuid(),
		name: 'Sina Ray',
		image: Avatar13,
		topic: 'Front End Developer'
	},
	{
		id: uuid(),
		name: 'Reva Yokk',
		image: Avatar12,
		topic: 'Engineering Architect'
	},
	{
		id: uuid(),
		name: 'Xiaon Merry',
		image: Avatar18,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: uuid(),
		name: 'Sina Ray',
		image: Avatar3,
		topic: 'Engineering Architect'
	},
	{
		id: uuid(),
		name: 'Nia Sikhone',
		image: Avatar4,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: uuid(),
		name: 'Nia Sikhone',
		image: Avatar17,
		topic: 'Web Developer, Designer, and Teacher'
	},
	{
		id: uuid(),
		name: 'Rivao Luke',
		image: Avatar17,
		topic: 'Web Development'
	}
];

export default TeamData;
